<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <order-state-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import OrderStateProvider from "../../../../providers/OrderStateProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import OrderStateForm from "../OrderStateForm";
  
    

    export default {
        name: "OrderStateUpdate",
        
        components: { OrderStateForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'delivery.orderState.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    state: this.item.state,
                    takeAwayMessage: this.item.takeAwayMessage,
                    deliveryMessage: this.item.deliveryMessage
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    OrderStateProvider.updateOrderState(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateOrderState)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

